import React, { FC, useEffect } from 'react';
import './App.css';
import { useRoutes } from 'react-router-dom';
import Routes from 'routes';
import 'react-toastify/dist/ReactToastify.css';
import 'simplebar-react/dist/simplebar.min.css';
import { ToastContainer, toast } from 'react-toastify';
import useUserStore from 'state/userStore';
import { useLocation } from 'react-router-dom';

const App: FC = () => {
  const authToken = window.localStorage.getItem('token');
  const { fetchUser, clearErrors, errors } = useUserStore();

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (authToken) {
      fetchUser(authToken);
    }
    return;
  }, [authToken]);

  useEffect(() => {
    if (errors.length) {
      errors.forEach((item) => toast.error(item));
      clearErrors();
    }
  }, [errors]);

  const routes = useRoutes(Routes);
  return (
    <>
      <ToastContainer theme="colored" />
      {routes}
    </>
  );
};

export default App;
